// extracted by mini-css-extract-plugin
export default {"mainLayout":"MainLayout_mainLayout__OSXRS","mainContent":"MainLayout_mainContent__5+2ra"};